import ACTION_ITEMS from "../actionItems";

export function setSelectedTeamId(teamId) {
  return {
    type: ACTION_ITEMS.TEAM_VIEWER.TEAM.SET,
    payload: { teamId },
  };
}